import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Users, Building2, UserPlus, CheckCircle2 } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => setStats({})); }, []);

  const cards = [
    { label: "Total Leads", value: stats?.total_leads, icon: Users, color: "bg-blue-50 text-blue-600" },
    { label: "New Leads", value: stats?.new_leads, icon: UserPlus, color: "bg-gold/15 text-gold-dark" },
    { label: "Total Projects", value: stats?.total_projects, icon: Building2, color: "bg-emerald-50 text-emerald-600" },
    { label: "Published", value: stats?.published_projects, icon: CheckCircle2, color: "bg-purple-50 text-purple-600" },
  ];

  return (
    <div className="p-6 md:p-10">
      <h1 className="font-display text-3xl text-navy">Dashboard</h1>
      <p className="text-muted-foreground mt-1">Overview of your leads and projects.</p>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-5 mt-8">
        {cards.map((c) => (
          <div key={c.label} className="bg-white rounded-2xl border border-gray-100 shadow-card p-6" data-testid={`stat-${c.label.toLowerCase().replace(/ /g, "-")}`}>
            <span className={`inline-flex p-2.5 rounded-xl ${c.color} mb-4`}><c.icon className="w-5 h-5" /></span>
            {stats === null ? <Skeleton className="h-9 w-16" /> : <p className="font-display text-3xl text-navy">{c.value ?? 0}</p>}
            <p className="text-sm text-muted-foreground mt-1">{c.label}</p>
          </div>
        ))}
      </div>

      <div className="bg-white rounded-2xl border border-gray-100 shadow-card p-6 mt-8">
        <h2 className="font-display text-xl text-navy mb-4">Leads by Status</h2>
        {stats === null ? <Skeleton className="h-24" /> : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
            {Object.entries(stats.by_status || {}).map(([k, v]) => (
              <div key={k} className="p-4 rounded-xl bg-muted text-center">
                <p className="font-display text-2xl text-navy">{v}</p>
                <p className="text-xs text-muted-foreground mt-1">{k}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
